import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './IRCAllActivities.css';

const IRCAllActivities = () => {
  const [activeTab, setActiveTab] = useState('educational');
  const navigate = useNavigate();

  // Function to handle phone number clicks
  const handlePhoneClick = (phoneNumber, e) => {
    // Prevent the click from triggering the card navigation
    e.stopPropagation();

    // Remove any non-digit characters (like hyphens)
    const cleanedNumber = phoneNumber.replace(/\D/g, '');

    // Create the tel: link
    const telLink = `tel:${cleanedNumber}`;

    // Open the dialer (works on mobile devices)
    window.location.href = telLink;
  };

  // Remove the unused handleActivityClick function

  const activitiesData = {
    educational: {
      title: "EDUCATIONAL ACTIVITIES",
      items: [
        {
          id: "IRC-WOMEN-EMPOWERMENT-CENTRE-(IWEC)",
          title: "IRC WOMEN EMPOWERMENT CENTRE (IWEC)",
          link: "/irc-women",
          details: [
            "Centre-1-Baijipura Contact: 8087-0632-11",
            "Centre-2-Parbhani Contact: 9112-9112-06",
            "Centre-3-Ibrahim Park Contact: 8087-0632-12"
          ]
        },
        {
          id: "technical-institutes",
          title: "IRC TECHNICAL INSTITUTES",
          link: "/irc-technical",
          details: [
            "Institute 1 (Baijpura) Contact: 9112-9112-05",
            "Institute 2 (Lasur Station) Contact: 9112-9112-03",
            "Institute 3 (Khuldabad) Contact: 9112-9112-04",
            "Institute 4 (Fazilpura) Contact: 9112-9112-05"
          ]
        },

        {
          id: "IRC-STUDY-CENTRES",
          title: "IRC STUDY CENTRES",
          details: [
            "Centre 1 (Roshan Gate) Boys & Girls",
            "Centre 2 (Rohila Gali) Boys",
            "Centre 3 (Ibrahim Park) Boys & Girls",
          ],
          contact: "80-5555-7734",
          link: "/irc-study",
        },

        {
          id: "SKILLDEVELOPMENTPROGRAMS",
          title: "SKILL DEVELOPMENT PROGRAMS",
          details: [
            "In order to encourage underprivileged people of the society to take up industry-relevant skill training that will help them in securing a better livelihood, IRC organizes various skill development programs to enable them to start their own small scale businesses of manufacturing goods and earn to support their families.",
          ],
          // contact: "80-5555-7734",
          link: "/irc-skill",
        },

        {
          id: "FREE-BOOK-BANK",
          title: "FREE BOOK BANK",
          details: [
            "Our Free Book Bank is a community initiative where...",
          ],
          contact: "7537-9999-44",
          link: "/irc-freebookbank",
        },

        {
          id: "IRC-ARABIC-ACADEMY-(IAA)",
          title: "IRC ARABIC ACADEMY (IAA)",
          details: [
            "Branch-1: Rauza Bagh Contact: 80-5506-5506",
            "Branch-2: Rohila Gali Contact: 80-5507-5507",
          ],
          link: "/irc-arabic",
        },

        // {
        //   id: "arabic-academy",
        //   title: "IRC ARABIC ACADEMY",
        //   location: "Rauza Bagh",
        //   contact: "80-5506-5506",
        //   link: "/irc-arabic",
        // },



        // {
        //   id: "women-empowerment",
        //   title: "IRC WOMEN EMPOWERMENT CENTRES",
        //   link: "/irc-women",
        // },
        // {
        //   id: "irc-minority-development-center",
        //   title: "IRC MINORITY DEVELOPMENT CENTRES",
        //   link: "/irc-minority",
        // },
        // {
        //   id: "irc-summer-camp",
        //   link: "/irc-summer",
        //   title: "IRC SUMMER CAMP"
        // },
        // {
        //   id: "irc-educational-aids",
        //   link: "/irc-study",
        //   title: "IRC EDUCATIONAL AIDS"
        // },
        // {
        //   id: "irc-educational-expo",
        //   link: "/irc-study",
        //   title: "IRC EDUCATIONAL EXPO"
        // },
      ]
    },
    medical: {
      title: "MEDICAL ACTIVITIES",
      items: [
        {
          id: "charitable-clinics",
          title: "IRC CHARITABLE CLINICS",
          link: "/irc-charity",
          details: [
            "Clinic 1 (Baijipura) Contact: 80-5555-7732",
            "Clinic 3 (Buddilane) Contact: 7537-9999-22",
            "Clinic 2 - Ibrahim Park Contact: 8507-8507-34",
          ]
        },
        {
          id: "dental-clinic",
          title: "IRC DENTAL CLINIC",
          link: "/irc-charity",
          details: [
            "Dental 1 (Baijipura) Contact: 9607-9607-67",
            "Dental 2 (Kiradpura) Contact: 8507-8507-32",
            "Dental 3 (Buddilane) Contact: 7537-9999-22",
            "Dental 4 (Ibrahim Park) Contact: 8507-8507-34",
          ]
        },
        {
          id: "pathology-lab",
          link: "/irc-charity",
          title: "IRC PATHOLOGY LAB",
          details: [
            "Baijipura"
          ],
          contact: "9607-9607-68"
        },
        // {
        //   id: "medical-clinic",
        //   title: "IRC MEDICAL CLINIC",
        //   link: "/irc-charity",
        //   details: [
        //     "Dental 1 (Baijipura) Contact: 9607-9607-67",
        //     "Dental 2 (Kiradpura) Contact: 8507-8507-32",
        //     "Dental 3 (Buddilane) Contact: 7537-9999-22"
        //   ]
        // },
        {
          id: "medical-aid",
          title: "MEDICAL AID",
          link: "/irc-charity",
          details: [
            "MEDICAL CAMPS",
            "MEDICAL GUIDANCE"
          ]
        },

      ]
    },
    social: {
      title: "SOCIAL SERVICES",
      items: [
        {
          id: "community-centres",
          title: "IRC COMMUNITY CENTRES",
          link: "/irc-community",
          details: [
            "Centre 1 (Baijipura) Contact: 80-5555-7732",
            "Centre 2 (Padegaon) Contact: 7537-9999-00",
            "Centre 3 (Fazilpura) Contact: 9607-05-2142",
            "Centre 4 (Ibrahim Park) Contact: 7537-9999-00",
            "Centre 5 (Rohila Gall)"
          ]
        },
        {
          id: "water-supplies",
          title: "IRC FREE WATER SUPPLIES",
          link: "/irc-water",
          details: [
            "Supply 1 (Rohila Gall)",
            "Supply 2 (Ambar Hill)",
            "Supply 3 (Ibrahim Park)",
          ],
          contact: "7537-9999-00"
        },
        {
          id: "dastarkhawan",
          title: "IRC DASTARKHAWAN",
          link: "/irc-dastar",
          contact: "80-5545-5545",
          details: [
            "IRC FREE FOOD DISTRIBUTION",
            "EMPLOYMENT AID",
            "IRC DASTARKHWAN"
          ]
        },
        {
          id: "call-centre",
          title: "IRC Helpline",
           details: [
            "Our help line provides authentic Islamic guidance on various matters including:",
          ],
          link: "/irc-call",
          contact: "80-5545-5545"
        },
        {
          id: "employment",
          title: "IRC EMPLOYMENT CENTER",
          link: "/irc-study",
          contact: "80-5545-5545"
        },
        {
          id: "IRC MINORITY-DEVELOPMENT-CENTER-(MDC)",
          title: "IRC MINORITY DEVELOPMENT CENTER (MDC)",
          details: [
            "Branch-1: Roshan Gate Contact: 80-5509-5509",
            "Branch-2: Ibrahim Park Contact: 9607-9607-69",
          ],
          link: "/irc-minority",
        }
      ]
    }
  };

  return (
    <div className="irc-activities">
      {/* Page Title - Centered for all devices */}
      <h1 className="page-title">IRC ACTIVITIES</h1>

      <div className="tabs-container">
        <div className="tabs">
          {Object.keys(activitiesData).map((tab) => (
            <button
              key={tab}
              className={`tab ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {/* Show short title on mobile, full title on larger screens */}
              <span className="tab-full-title">{activitiesData[tab].title}</span>
              <span className="tab-short-title">{activitiesData[tab].shortTitle}</span>
            </button>
          ))}
        </div>
      </div>

      <div className="tab-content">
        {activitiesData[activeTab].items.map((item) => (
          <div
            key={item.id}
            className="activity-card"
            onClick={() => navigate(item.link)}
          >
            <h3 className="card-title">{item.title}</h3>

            {item.subtitle && <p className="card-subtitle">{item.subtitle}</p>}
            {item.location && <p className="card-location">{item.location}</p>}

            {item.details && (
              <ul className="card-details">
                {item.details.map((detail, i) => {
                  // Check if the detail contains a phone number
                  const contactMatch = detail.match(/Contact: ([\d-]+)/);
                  if (contactMatch) {
                    const phoneNumber = contactMatch[1];
                    const detailWithoutContact = detail.replace(/Contact: [\d-]+/, '');

                    return (
                      <li key={i}>
                        {detailWithoutContact}
                        <span
                          className="contact-number"
                          onClick={(e) => handlePhoneClick(phoneNumber, e)}
                          style={{ cursor: 'pointer', color: '#e8252d', textDecoration: 'underline', marginLeft: '5px' }}
                        >
                          Contact: {phoneNumber}
                        </span>
                      </li>
                    );
                  }
                  return <li key={i}>{detail}</li>;
                })}
              </ul>
            )}

            {item.contact && (
              <div className="contact-info">
                <span className="contact-label">Contact: </span>
                <span
                  className="contact-number"
                  onClick={(e) => handlePhoneClick(item.contact, e)}
                  style={{ cursor: 'pointer', color: '#e8252d', textDecoration: 'underline' }}
                >
                  {item.contact}
                </span>
              </div>
            )}

            <div className="card-cta">
              <span className="cta-text">Learn more →</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default IRCAllActivities;